import { Component, OnInit, input, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
  selector: 'app-control-label',
  templateUrl: './control-label.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./control-label.component.scss']
})
export class ControlLabelComponent {

  control = input.required<AbstractControl | null>()
  caption = input.required<string>()

  get isRequired(): boolean {
    if (!this.control()?.validator) {
      return false;
    }
    const validator = this.control()?.validator({} as AbstractControl);
    return (validator?.required) ?? false;
  }

  get isEnabled(): boolean {
    return this.control()?.status === 'DISABLED' ? false : true;
  }

}
